import script from "./ReporteSyncEstudyoo.vue?vue&type=script&setup=true&lang=js"
export * from "./ReporteSyncEstudyoo.vue?vue&type=script&setup=true&lang=js"

import "./ReporteSyncEstudyoo.vue?vue&type=style&index=0&id=1d7b8410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7b8410"]])

export default __exports__